const sharePageLink = (url: string, title: string, text: string, alertInitialMessage: string) => {
  const alertText = `${alertInitialMessage}:\n\n${url}`
  // navigator available
  if (navigator) {
    try {
      navigator.share({ title, text, url })
    } catch (shareError) {
      // console log error
      console.log(shareError)
      // copy to clipboard instead
      try {
        navigator.clipboard.writeText(url)
        alert('The URL has been copied to clipboard!')
      } catch (copyError) {
        // console log error
        console.log(copyError)
        // just show an alert of the profile
        alert(alertText)
      }
    }
  }
  // navigator not available
  else {
    console.log('navigator not available')
    // just show an alert of the profile
    alert(alertText)
  }
}

type useShareReturnType = {
  sharePageLink: typeof sharePageLink
}

export function useShare(): useShareReturnType {
  return {
    sharePageLink
  }
}
